import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px 1px 2px 0px var(--neutral-grey-transparent-k-20, rgba(0, 0, 0, 0.2));
  background: ${({ theme }) => theme.backgroundColor};
  padding: 20px;
  color: ${({ theme }) => theme.textColor};
`;
